export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm5.03 5.97a.75.75 0 0 0-1.06 0l-6.306 6.305-1.513-2.647a.75.75 0 0 0-1.302.744l1.838 3.216a1 1 0 0 0 1.575.21L17.03 9.03a.75.75 0 0 0 0-1.06Z"/>
</svg>
`;
